<script>
import meta from '../utils/meta'
export default {
  name: 'top-bar',
  props: {
    logout: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogs: [{
        show: false
      }],
      images: {
        backBtn: 'data:application/octet-stream;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAUCAYAAAC58NwRAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAADKADAAQAAAABAAAAFAAAAABDnCYeAAABAElEQVQoFWNgIAD+///PaG5uHgLENiCljPjUQxVP/f+fIROo7puIiLAQEy4NaIpBZh/cvn37TxZsGtAVMzIyHBIQ4A8FqcVwEnbFAl67du36iqGBkGIUDcQohmsgVjFIAwtEscV0YNClg00AexDhZpAYMmA0MzMDKc4ACTIyMh4BhoYHzIPICmFsUDxcAOL/UAGZL1++iMAksdHgYAXakg60ZTpQAdASxgcsLMwOx44de4hTA0iCWE0oEUeMJhQNxNiEoYGQJqwa8GnCmbxPnTo1E5hKQfkAGLf/Ff78+bMVFMk4bQDZAgKwgAAG9ysDA31ZiCgB0srKStnBwQEcoQBF4qgZxl4YtwAAAABJRU5ErkJggg==',
        logoutBtn: 'data:application/octet-stream;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAUCAYAAABiS3YzAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAFaADAAQAAAABAAAAFAAAAAA1ezu+AAAB20lEQVQ4EZ3UOy8EURjG8V3Xgoh1a1wikQiNlsZGQk+iFaUVlbgEhYYvQKtBtuMz2GI1JK6FFSIo3AriLnEL/2fNrNkxZ1f2TX6ZM+fMvDNzzjvH70sdAYarUQA/nnGCBxhDF7pDfY3oRzMqUQLFDc4QxSJiSBt5XDGCQ3xBb7QNJVnFDp6gsT2MIhvGyGIkDN10iyW0ohS50APL0YEI3qHpGIMxhhh5wTlmoCSm0HSMYx3dpos0hwe4Q8h0kUd/LX1dyHGPaWFmoXlaRqo3ZDgpJjm7ghZNlZKIYlpreEQw0fu/huZXX6j5nYdyxV+7hmMVjqAVdUYDJ1ocU7wyMIVp9OATw5oLFbYm/hgqITv0sBVU2B1pjsrVi90/E+y48ZL2BlRSH45+d1N1qi8qwyl24WvCGVTkSuAOLaRJEWNz0JzqSzsRj0wXSj/LAN5wAZVWUmRaUvVk0Ru2JWWzTpzFrwf8Nzwrw94Mrsmiom9HnZVxk6NKxCtULYPQC2hB9+EZShqG/n97QwnS1uJpQ8mHyqsDEWhx7jGBlKHJd299W/RFLTscnVtfH+f219L8CZWKO9SnOQ6hBfrbAlDYm/Qq7QXE8Ce8kjovUjIlLbQ6tX+ewvnnWUO/h29/XWYivz/W9AAAAABJRU5ErkJggg=='
      },
    }
  },
  methods: {
    // 返回上一页
    back() {
      history.back()
    },
    // 退出登录并回到导航栏
    navLogout() {
      localStorage.removeItem('Authorization')
      localStorage.removeItem('banner')
      localStorage.removeItem('link')
      localStorage.removeItem('user')
      meta.user = null
      this.$router.push('/')
    },
  }
}
</script>

<template>
  <div class="top-bar">
    <img @click="back" class="back-btn" alt=""
         referrerpolicy="no-referrer" :src="images.backBtn"/>
    <img v-if="logout" @click="dialogs[0].show = true" class="logout-btn" alt=""
         referrerpolicy="no-referrer" :src="images.logoutBtn"/>

    <custom-dialog
      v-model="dialogs[0].show"
      :confirmText="$t('base.ok')"
      cancelType="primary"
      @confirm="navLogout"
      :title="$t('base.notice')"
      :info="$t('person_center[\'Are you sure you want to logout?\']')"
    />
  </div>
</template>

<style scoped>
.top-bar {
  display: flex;
  margin: 2vw 1vw;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.back-btn {
  width: 3.2vw;
  height: 5.34vw;
  margin-top: 0.54vw;
}

.logout-btn {
  width: 5.07vw;
  height: 4.8vw;
}
</style>



// WEBPACK FOOTER //
// src/components/TopBar.vue